import { useCallback, useState } from 'react'

interface UseOrderContainerizationResult {
    withoutContainerization: boolean
    toggle: () => void
    setWithoutContainerization: (value: boolean) => void
}

/**
 * Owns the "sin contenerización" switch state for order creation.
 *
 * The flag is orthogonal to the operation mode: this hook never reads or derives
 * the mode. `false` means the order has containerization (current behavior).
 */
export function useOrderContainerization(
    initialValue = false
): UseOrderContainerizationResult {
    const [withoutContainerization, setWithoutContainerization] = useState(initialValue)

    const toggle = useCallback(() => {
        setWithoutContainerization((prev) => !prev)
    }, [])

    return { withoutContainerization, toggle, setWithoutContainerization }
}
